import { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import {
  Box,
  Button,
  Container,
  Group,
  Loader,
  Paper,
  Stack,
  Text,
  Title,
} from '@mantine/core'
import { notifications } from '@mantine/notifications'
import { ArrowLeft } from 'lucide-react'
import api from '../../api/client'
import { RichText } from '../../components/common/RichText'

export function QuizReview() {
  const { assignmentId } = useParams<{ assignmentId: string }>()
  const navigate = useNavigate()
  const [report, setReport] = useState<string | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!assignmentId) return
    api
      .post<{ report: string }>(`/assignments/${assignmentId}/review`)
      .then((res) => setReport(res.data.report))
      .catch((err) => {
        const msg = err?.response?.data?.detail || 'Failed to load review'
        notifications.show({ title: 'Error', message: msg, color: 'red' })
        setReport(null)
      })
      .finally(() => setLoading(false))
  }, [assignmentId])

  if (loading) {
    return (
      <Box style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '60vh', gap: 12 }}>
        <Loader color="eveningSea" />
        <Text size="sm" c="var(--sat-text-muted)">Generating review report... This may take a moment.</Text>
      </Box>
    )
  }

  return (
    <Container size="md" py="xl">
      <Stack gap="lg">
        <Group>
          <Button
            variant="subtle"
            color="gray"
            leftSection={<ArrowLeft size={16} />}
            onClick={() => navigate('/study-plan')}
          >
            Back to Study Plan
          </Button>
        </Group>

        <Title order={2} c="var(--sat-text)">Quiz Review</Title>

        <Paper
          radius="md"
          p="lg"
          style={{ background: 'var(--sat-surface)', border: '1px solid var(--sat-border)' }}
        >
          {report ? (
            <RichText size="md">{report}</RichText>
          ) : (
            <Text c="var(--sat-text-muted)" ta="center" py="xl">
              No review available.
            </Text>
          )}
        </Paper>
      </Stack>
    </Container>
  )
}
